module.exports = __webpack_public_path__ + "static/media/trivia.5cf63dde.jpg";